import alasql from 'alasql';
import moment from 'moment';
import('moment-range');


export default moment